export default "__VITE_PUBLIC_ASSET__caca036a__"